import type { I18n, VueI18n } from 'vue-i18n';

export const I18nOrigin = Symbol('I18nOrigin');
export const I18nService = Symbol('I18nService');

export type I18nOrigin = I18n

export type I18nService = VueI18n
